var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.context.classes.element,
      attrs: { "data-has-files": _vm.hasFiles, "data-type": _vm.context.type }
    },
    [
      _c(
        "FormulateSlot",
        { attrs: { context: _vm.context, name: "prefix" } },
        [
          _vm.context.slotComponents.prefix
            ? _c(_vm.context.slotComponents.prefix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.context.classes.uploadArea,
          attrs: { "data-has-files": _vm.hasFiles }
        },
        [
          _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  ref: "file",
                  attrs: { "data-is-drag-hover": _vm.isOver, type: "file" },
                  on: {
                    blur: _vm.context.blurHandler,
                    change: _vm.handleFile,
                    dragleave: _vm.handleDragLeave,
                    dragover: _vm.handleDragOver
                  }
                },
                "input",
                _vm.attributes,
                false
              ),
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "FormulateSlot",
            {
              attrs: {
                context: _vm.context,
                "has-files": _vm.hasFiles,
                name: "uploadAreaMask"
              }
            },
            [
              _c(_vm.context.slotComponents.uploadAreaMask, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hasFiles,
                    expression: "!hasFiles"
                  }
                ],
                tag: "component",
                class: _vm.context.classes.uploadAreaMask,
                attrs: {
                  "data-has-files":
                    _vm.context.slotComponents.uploadAreaMask === "div"
                      ? _vm.hasFiles
                      : false,
                  "has-files":
                    _vm.context.slotComponents.uploadAreaMask === "div"
                      ? false
                      : _vm.hasFiles
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFiles
            ? _c("FormulateFiles", {
                attrs: {
                  context: _vm.context,
                  files: _vm.context.model,
                  "image-preview": true
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "FormulateSlot",
        { attrs: { context: _vm.context, name: "suffix" } },
        [
          _vm.context.slotComponents.suffix
            ? _c(_vm.context.slotComponents.suffix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.cropperShow
        ? _c(
            "div",
            {
              staticClass: "modal d-flex",
              attrs: { role: "dialog", tabindex: "-1" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog align-self-center",
                  attrs: { role: "document" }
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Bild zuschneiden")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { "aria-label": "Close", type: "button" },
                          on: { click: _vm.cropperHideModal }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body d-flex align-items-center" },
                      [
                        _c("vue-cropper", {
                          ref: "cropper",
                          attrs: {
                            "aspect-ratio": _vm.aspectRatio,
                            src: _vm.cropperImgSrc,
                            alt: "Source Image"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "cropper__controls position-absolute w-100 d-flex justify-content-between"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mx-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.cropperRotate(-90)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-undo" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mx-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.cropperRotate(90)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-redo" })]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.cropperCropImage }
                        },
                        [
                          _vm._v("Speichern "),
                          _c("i", { staticClass: "fas fa-save" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cropperHideModal }
                        },
                        [
                          _vm._v("Abbrechen "),
                          _c("i", { staticClass: "fas fa-times" })
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }